module.exports = __webpack_public_path__ + "media/src/images/icons/flags/france-f33e48c1d55e642d1000bc0a015de205.svg";